import {BifrostBackendApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const VersionProvider = {
	async getVersion(tenantID, shopId = null) {
		const versionResponse = await BifrostBackendApi
			.get("/version", {
				headers: {
					"Cache-Control": "no-cache"
				},
				params: {
					tenantID,
					...(shopId ? {shopId} : {})
				}
			});
		if (!versionResponse.data || !versionResponse.data.version || versionResponse.data.version.success) {
			return versionResponse;
		}

		const isMobile = appConfig.mobile.isMobileApp();
		const baseUrl = isMobile ? appConfig.getBaseUrl() : window.location.origin;
		const url = `${baseUrl}/static/version.json`;
		const staticVersion = await fetch(url)
			.then((res) => res.json())
			.catch(() => null);

		if (!staticVersion) {
			return versionResponse;
		}

		return {
			...versionResponse,
			data: {
				...versionResponse.data,
				version: {
					success: true,
					data: staticVersion
				}
			}
		};
	}
};

export default Object.freeze(VersionProvider);
